import { render, staticRenderFns } from "./CommunityPackageCard.vue?vue&type=template&id=9b64e3fe&"
import script from "./CommunityPackageCard.vue?vue&type=script&lang=ts&"
export * from "./CommunityPackageCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityPackageCard.vue?vue&type=style&index=0&id=9b64e3fe&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports